export function elParseTemplatedExpression (text, itemData, useLowercase, emptyWipe = false) {
  if (!text) {
    return '';
  }

  const regex = /\[(free|free_raw|property|property_raw|variationProperty|variationProperty_raw)\((.*?)\)\]/g;
  const funcs = text.match(regex);

  let emptyFunctionFlag = false;

  if (funcs) {
    funcs.forEach((item) => {
      regex.lastIndex = 0;
      item = regex.exec(text);
      if (item && item[0]) {
        let resultVal = '';
        let isFuncFound = true;

        if (item[0].startsWith('[free(') || item[0].startsWith('[free_raw(')) {
          resultVal = itemData.freeFields ? itemData.freeFields['free' + item[2]] : '';
        } else if (item[0].startsWith('[property(') || item[0].startsWith('[property_raw(')) {
          const property = itemData.properties.find(prop => prop.property.id == item[2]);

          if (property && property.texts && property.texts.value) {
            resultVal = property.texts.value;
          }
        } else if (item[0].startsWith('[variationProperty(') || item[0].startsWith('[variationProperty_raw(')) {
          if (itemData.variationProperties) {
            itemData.variationProperties.forEach((propertyGroup) => {
              if (propertyGroup.properties) {
                const variationProperty = propertyGroup.properties.find(prop => prop.id == item[2]);

                if (variationProperty && variationProperty.values && variationProperty.values.value) {
                  resultVal = variationProperty.values.value;
                }
              } else if (propertyGroup.property) {
                if (propertyGroup.property.id == item[2]) {
                  if (propertyGroup.values && propertyGroup.values.value) {
                    resultVal = propertyGroup.values.value;
                  }
                }
              }
            });
          }
        } else {
          isFuncFound = false;
        }

        if (isFuncFound) {
          if (!resultVal || resultVal == '0') {
            emptyFunctionFlag = true;
            text = text.replace(item[0], '');
          } else {
            if (useLowercase) {
              resultVal = resultVal.toLowerCase();
            }
            if (!item[0].includes('_raw(')) {
              resultVal = encodeURIComponent(resultVal);
            }
            text = text.replace(item[0], resultVal);
          }
        }
      }
    });
  }

  if (emptyWipe && emptyFunctionFlag) {
    text = '';
  }

  text = text.replace(/\[manufacturer\]/g, itemData.item.manufacturer.externalName);
  text = text.replace(/\[articlenumber\]/g, itemData.variation.number);
  text = text.replace(/\[externalId\]/g, itemData.variation.externalId);

  return text;
}
